/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import { DesktopDatePicker } from "@material-ui/pickers";
import {
  makeStyles,
  Grid,
  Theme,
  createStyles,
  TextField,
  ThemeProvider,
  createTheme as createMuiTheme
} from "@material-ui/core";
import CalendarTodayRoundedIcon from "@material-ui/icons/CalendarTodayRounded";
import { ViewModeTextField } from "../text-fields/ViewModeTextField";
import { IconTooltip } from "../../icons/IconTooltip";

const useStyles = makeStyles((_outerTheme: Theme) =>
  createStyles({
    iconCalender: {
      fontSize: "1rem !important",
      color: "#32325D",
      pointerEvents: "auto",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    outerDiv: {
      flex: 1,
      width: "100%"
    }
  })
);

const outerTheme = createMuiTheme({
  overrides: {
    MuiTextField: {
      root: {
        width: "100%"
      }
    },
    MuiInputBase: {
      input: {
        padding: "13px 14px !important"
      }
    }
  }
});
interface DatePickerV1Props {
  isViewMode: boolean;
  label?: string;
  lableStyles?: any;
  requiredAstrick?: boolean;
  selectedDate: string;
  setSelectedDate: any;
  showInfoIcon?: boolean;
  infoIconData?: any;
  inputStyles?: any;
  viewModeStyle?: any;
  editedLabel?: any;
  editedData?: any;
  editComponent?: any;
}

export function DatePickerV1(props: DatePickerV1Props) {
  const {
    isViewMode,
    label,
    lableStyles,
    requiredAstrick,
    selectedDate,
    setSelectedDate,
    showInfoIcon,
    infoIconData,
    inputStyles,
    viewModeStyle,
    editedLabel,
    editedData,
    editComponent
  } = props;
  const classes = useStyles();

  return isViewMode ? (
    <ViewModeTextField
      label={label}
      style={viewModeStyle}
      infoIconData={infoIconData}
      value={selectedDate}
      editedLabel={editedLabel}
      editedData={editedData}
      editComponent={editComponent}
    />
  ) : (
    <ThemeProvider theme={outerTheme}>
      <DesktopDatePicker
        inputFormat="MM/dd/yyyy"
        className={classes.outerDiv}
        openPickerIcon={
          <CalendarTodayRoundedIcon className={classes.iconCalender} />
        }
        value={selectedDate}
        onChange={date => setSelectedDate(date)}
        renderInput={({ ref, inputProps, InputProps }) => {
          return (
            <TextField
              ref={ref}
              label={
                <Grid container justify="space-between">
                  <Grid item xs={9}>
                    {label}
                    {requiredAstrick ? (
                      <span style={{ color: "#f75676", fontWeight: "bold" }}>
                        {" "}
                        *
                      </span>
                    ) : null}
                  </Grid>
                  {showInfoIcon ? (
                    <Grid item>
                      <IconTooltip
                        topic="Information"
                        infoIconData={infoIconData}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              }
              inputProps={inputProps}
              InputProps={{
                ...InputProps,
                style: {
                  width: "100%",
                  ...inputStyles
                }
              }}
              InputLabelProps={{
                shrink: false,
                style: {
                  position: "relative",
                  color: "#8897aa",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1.5,
                  transform: "none",
                  ...lableStyles
                }
              }}
              id="outlined-basic"
              variant="outlined"
              onKeyDown={evt => {
                const charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode !== 9) {
                  evt.preventDefault();
                  return false;
                }
                return true;
              }}
            />
          );
        }}
      />
    </ThemeProvider>
  );
}
